module.exports = __webpack_public_path__ + "static/screen-orari-bezels-4c5cdfdbc7ca34552d37a8d437a4dba2.png";